import { BadgeQuestionMark } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BadgeQuestionMarkIcon = createLucideIcon(BadgeQuestionMark);
